// src/modules/common/components/Typography/Heading/Heading.jsx
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { NAMESPACE } from "../../../namespace";
import withEmphasis from "../withEmphasis";
import "./Heading.css";

class Heading extends PureComponent {
  static propTypes = {
    level: PropTypes.oneOf([1, 2, 3, 4, 5, 6, "banner"]),
    className: PropTypes.string,
  };

  static defaultProps = {
    level: 1,
    className: "",
  };

  render() {
    // eslint-disable-next-line prefer-const
    let { level, children, className, ...props } = this.props;
    let elementName = "";
    if (level !== "banner") {
      elementName = `h${level}`;
    } else {
      elementName = "h1";
      className = `${className} banner`;
    }

    return React.createElement(
      elementName,
      { className: `${NAMESPACE}Heading ${className}`, ...props },
      children,
    );
  }
}

export default withEmphasis(Heading);
